import { formatUkDateFromString } from '../../utils/stringUtils';
import DataTable from '../DataTable';

const UserAudit = ({ auditLog = [], loading }) => {
  return (
    <div className="skills-matrix">
      <section className="pt-3">
        <DataTable
          dontRefreshPagination
          idKey="idx"
          data={auditLog}
          className="table-striped"
          lazyLoading
          isLoading={loading}
        >
          <DataTable.Column colKey="event" header="Event" />
          <DataTable.Column colKey="dateTime" header="Date and Time">
            {(item) => {
              return formatUkDateFromString(item.dateTime, true);
            }}
          </DataTable.Column>
          <DataTable.Column colKey="updatedBy" header="Updated By" />
        </DataTable>
      </section>
    </div>
  );
};

export default UserAudit;
